var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _g3, _path13, _g4, _path14, _g5, _path15, _g6, _path16, _g7, _path17, _g8, _path18, _g9, _path19, _g10, _path20, _g11, _path21, _g12, _path22, _g13, _path23, _g14, _path24, _path25, _path26, _path27, _path28, _path29, _g15, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingApproval1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 326,
    viewBox: "0 0 247 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_9059)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 0,
    width: 95,
    height: 239
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.555 0H239V238.743H144.555V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.193 238.66L156.418 231.115C149.664 230.363 144.555 224.64 144.555 217.828V20.9159C144.555 14.1032 149.664 8.38018 156.418 7.62851L224.193 0.0831887C232.092 -0.795816 239 5.40323 239 13.371V225.373C239 233.341 232.092 239.54 224.193 238.66",
    fill: "#1E2327"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.61 216.987L232.836 225.926L232.77 23.8127L147.557 32.7503L147.61 216.987Z",
    fill: "#10BEF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.375 16.854C184.29 16.854 183.41 17.9218 183.41 19.2391C183.41 20.5565 184.29 21.6247 185.375 21.6247C186.459 21.6247 187.339 20.5565 187.339 19.2391C187.339 17.9218 186.459 16.854 185.375 16.854",
    fill: "#697079"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.88 18.0493C191.339 18.0493 190.9 18.582 190.9 19.2389C190.9 19.8962 191.339 20.4289 191.88 20.4289C192.421 20.4289 192.86 19.8962 192.86 19.2389C192.86 18.582 192.421 18.0493 191.88 18.0493",
    fill: "#697079"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.286 108.404C149.473 127.265 155.399 133.536 134.165 122.408L127.453 124.869L125.426 130.94L133.609 139.212C142.557 148.256 156.475 150.088 167.448 143.664L173.557 140.088C173.557 140.088 181.099 89.5419 165.286 108.404",
    fill: "#D8E5E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.888 124.728C113.299 120.711 115.283 114.812 118.596 112.666C121.909 110.52 125.299 112.941 127.887 116.958C128.624 118.103 129.103 119.327 129.335 120.542C130.633 120.616 132.266 121.086 134.166 122.407L125.426 130.94C125.113 130.217 118.013 128.027 115.888 124.728",
    fill: "#EFB87B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.428 114.056C122.428 113.633 122.362 113.234 122.24 112.832C122.115 112.435 121.919 112.045 121.626 111.714C121.485 111.544 121.306 111.41 121.125 111.276C120.929 111.17 120.732 111.055 120.515 111C120.304 110.915 120.086 110.9 119.868 110.865C119.65 110.843 119.436 110.856 119.218 110.853C119.002 110.85 118.824 111.023 118.82 111.24C118.817 111.457 118.99 111.636 119.207 111.639C119.217 111.639 119.227 111.639 119.236 111.639L119.304 111.634C119.477 111.623 119.656 111.592 119.828 111.593C119.997 111.606 120.176 111.597 120.336 111.648C120.507 111.672 120.656 111.747 120.814 111.808C120.955 111.897 121.104 111.982 121.225 112.105C121.478 112.339 121.677 112.646 121.82 112.985C121.961 113.322 122.06 113.7 122.094 114.061L122.095 114.073C122.104 114.165 122.186 114.232 122.277 114.223C122.363 114.215 122.428 114.141 122.428 114.056",
    fill: "#3A3F41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.239 113.602C123.1 108.149 128.127 109.969 129.921 113.888C131.639 117.64 131.678 121.601 128.098 121.887C127.785 121.913 127.508 122.087 127.352 122.359C125.482 125.628 122.05 123.86 119.339 120.74C116.514 117.489 116.927 112.147 122.239 113.602",
    fill: "#F05A60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.793 112.878C124.915 112.894 125.044 112.879 125.165 112.825C125.293 112.77 125.502 112.776 125.742 112.845C126.112 112.948 126.502 112.733 126.607 112.36C126.713 111.987 126.497 111.598 126.124 111.492C125.562 111.332 125.036 111.348 124.605 111.537C124.25 111.692 124.087 112.106 124.242 112.462C124.344 112.696 124.558 112.846 124.793 112.878",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.901 113.162C127.005 113.468 127.338 113.632 127.644 113.527C127.95 113.422 128.113 113.089 128.008 112.782C127.903 112.475 127.571 112.312 127.265 112.417C126.959 112.521 126.796 112.855 126.901 113.162",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125L147.557 32.7505Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.396 182.829L164.585 190.352L160.268 220.401L211.559 228.576L214.414 198.013L180.396 182.829Z",
    fill: "#103540"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.009 68.8718L201.202 65.975C200.885 63.2142 199.755 60.5915 197.682 58.841C195.246 56.7839 191.312 56.033 188.32 55.0914C184.72 53.9585 177.635 52.7637 174.068 52.2009C172.113 51.8923 170.118 51.903 168.178 52.2941C167.114 52.5087 166.117 52.828 165.649 53.3008C164.317 54.6471 163.41 56.7474 163.178 58.8632C162.946 60.9794 162.154 68.3149 167.264 71.3038C166.017 69.612 165.273 67.9694 164.87 66.4359C165.081 66.8112 165.308 67.1769 165.555 67.5291C167.535 70.3545 172.702 71.3169 174.528 74.2593C176.45 77.358 179.662 79.9907 182.488 82.3008C184.035 83.5654 185.733 84.7986 187.71 85.0791C188.313 85.1647 188.954 85.1524 189.499 84.8791C189.87 84.6931 190.174 84.3992 190.472 84.1092C190.907 83.6856 191.342 83.2616 191.777 82.8379C193.393 85.5916 196.379 87.4412 199.797 87.4412C204.934 87.4412 209.098 83.2659 209.098 78.1157C209.098 73.3779 205.573 69.468 201.009 68.8718",
    fill: "#5E3A30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.004 132.158C224.333 117.37 218.428 109.316 212.221 103.114C208.876 99.3123 203.497 97.1827 195.481 96.1251L195.478 96.1307L192.661 73.8113L179.091 77.4344L181.587 94.2684C181.847 96.0264 181.769 98.2029 181.769 98.2029C167.909 103.785 165.19 107.505 163.838 114.741C161.49 127.304 167.103 140.787 168.238 148.055C168.636 154.967 165.836 184.314 164.584 190.352C164.584 190.352 193.817 196.68 214.413 198.013C216.665 179.955 215.533 169.697 214.864 160.779C215.008 160.736 215.136 160.694 215.249 160.653C215.249 160.653 217.544 160.295 220.82 158.548C222.294 157.761 223.966 156.694 225.717 155.251C232.495 149.667 234.619 140.171 231.004 132.158",
    fill: "#EFB87B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.004 132.158C224.333 117.37 218.428 109.316 212.221 103.114C209.345 99.8442 204.963 97.8117 198.694 96.634C196.478 104.451 186.18 107.116 182.858 106.783C179.536 106.449 177.543 103.452 178.4 99.6205C167.447 104.459 165.073 108.134 163.838 114.74C161.49 127.304 167.103 140.787 168.238 148.055C168.636 154.967 165.836 184.314 164.584 190.352C164.584 190.352 193.817 196.68 214.413 198.013C216.665 179.955 215.533 169.697 214.864 160.779C215.008 160.736 215.136 160.694 215.249 160.653C215.249 160.653 217.544 160.295 220.82 158.548C222.294 157.761 223.966 156.694 225.717 155.251C232.495 149.667 234.619 140.171 231.004 132.158",
    fill: "#D8E5E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.103 150.096C191.404 150.564 187.659 151.587 188.061 155.648C188.462 159.709 191.564 163.086 197.474 163.107C198.9 163.112 200.629 162.978 202.511 162.813C202.924 162.776 203.606 162.699 204.443 162.592C204.382 157.365 202.646 152.673 199.906 149.411C198.653 149.727 197.384 149.969 196.103 150.096",
    fill: "#EFB87B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.238 57.5153C173.473 57.4506 170.043 62.2499 168.4 70.6512C168.129 71.7011 166.815 77.0363 167.346 78.1223C167.875 79.2068 169.414 79.8022 170.658 79.8538C171.69 87.1932 174.653 91.0956 179.363 91.1344C185.78 91.188 191.876 84.8545 191.974 72.9804C192.053 63.4276 189.571 57.5843 181.238 57.5153",
    fill: "#EFB87B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.395 70.9077C180.412 74.2634 178.561 77.0028 176.271 77.0143C173.981 77.0254 172.105 74.3047 172.088 70.9485C172.071 67.5927 173.921 64.8534 176.211 64.8423C178.502 64.8308 180.378 67.5519 180.395 70.9077M164.607 76.111C162.757 76.1201 161.24 73.8282 161.227 71.0024C161.213 68.1766 162.706 65.87 164.556 65.8608C166.406 65.8517 167.922 68.1432 167.936 70.9691C167.95 73.7953 166.456 76.1019 164.607 76.111M176.207 63.8811C173.389 63.895 171.111 67.0675 171.131 70.9533C171.131 71.0607 171.134 71.1674 171.138 71.2738L168.245 71.2638C168.31 71.0005 168.363 70.7882 168.399 70.6514C168.494 70.1643 168.596 69.6903 168.704 69.2278C168.16 66.7193 166.501 64.8903 164.551 64.8998C162.172 64.9117 160.251 67.6514 160.268 71.0072C160.284 74.363 162.232 77.0837 164.611 77.0718C165.66 77.0666 166.618 76.5287 167.362 75.6434C167.521 74.5153 167.789 73.2356 168.018 72.2305L171.223 72.2341C171.678 75.5077 173.776 77.9877 176.277 77.975C179.096 77.9611 181.373 74.7886 181.354 70.9029C181.335 67.0172 179.026 63.8673 176.207 63.8811",
    fill: "#EF5489"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.855 65.6214C182.065 69.2818 182.871 72.7089 185.204 75.6335C187.862 78.9639 191.848 78.9639 194.174 85.9579C197.496 80.9619 201.173 73.0088 198.879 68.2802C196.92 64.2414 194.179 60.1974 190.599 57.4227C188.442 55.75 187.167 57.5711 185.712 59.4739C184.328 61.2811 183.336 63.3937 182.855 65.6214",
    fill: "#5E3A30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.943 54.5419C183.612 54.956 185.27 55.459 186.823 55.8743C187.746 56.121 188.857 56.5859 188.912 57.5418C188.934 57.9298 188.759 58.3026 188.546 58.6271C187.7 59.9175 187.393 60.9646 185.888 61.2943C183.469 61.8242 179.797 61.0682 177.323 60.9853C174.849 60.9024 172.12 61.3446 170.503 63.2236C169.589 63.2986 168.756 62.543 168.495 61.6616C168.233 60.7806 168.434 59.8242 168.773 58.9702C171.223 52.8073 176.636 53.225 181.943 54.5419",
    fill: "#5E3A30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125L147.557 32.7505Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.027 121.607C184.48 112.617 190.524 101.768 196.812 96.1251C196.448 96.0375 195.483 96.1251 195.483 96.1251C189.52 101.39 184.393 110.899 181.182 118.51C181.199 109.114 181.199 105.783 181.771 98.2029C181.433 98.279 180.903 98.4781 180.567 98.5686C179.87 107.449 180.249 115.654 179.953 121.893L181.027 121.607Z",
    fill: "#103540"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125L147.557 32.7505Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.432 121.175C181.259 121.575 181.09 121.975 180.93 122.374L180.003 124.676L179.75 122.206C179.709 121.798 179.67 121.39 179.633 120.983L181.432 121.175Z",
    fill: "#6A707A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.614 135.425H177.561C177.003 135.425 176.547 134.967 176.547 134.408V124.445C176.547 123.886 177.003 123.428 177.561 123.428H182.614C183.172 123.428 183.629 123.886 183.629 124.445V134.408C183.629 134.967 183.172 135.425 182.614 135.425",
    fill: "#F4F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 23,
    width: 86,
    height: 203
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.557 32.7505L147.61 216.987L232.836 225.925L232.77 23.8125L147.557 32.7505Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.246 129.273H181.928V125.269H178.246V129.273Z",
    fill: "#F69159"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.944 151.762C75.6766 150.483 75.425 149.203 75.1971 147.925C74.6661 144.91 74.3084 141.896 74.1043 138.915C73.8709 135.349 70.9676 121.364 71.2434 117.773C71.3771 116.027 64.6535 121.501 64.9316 119.772C65.0567 118.993 67.8606 119.356 67.9279 118.577C68.3073 114.174 65.9951 111.504 61.7285 110.281C60.2258 109.85 65.2529 110.447 63.685 110.752C58.5819 111.746 56.1483 115.777 55.0302 120.354C52.6306 129.716 53.666 139.648 55.5802 148.81C56.2271 151.907 57.0168 154.965 57.922 157.988C59.5149 156.741 61.2565 155.645 63.1398 154.726C67.2521 152.72 71.6149 151.769 75.944 151.762",
    fill: "#1A586B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7554 191.286C94.7606 191.206 94.7634 191.124 94.7638 191.041C94.7562 188.227 92.6882 186.328 91.7604 185.617C91.1646 185.16 90.6407 184.651 90.1897 184.094C89.1313 182.789 86.0778 178.277 83.0269 172.724C80.7365 167.447 78.7441 162.061 77.1785 156.578C76.7207 154.974 76.3089 153.367 75.9306 151.761C71.6031 151.729 67.251 152.568 63.1576 154.383C61.283 155.214 59.5517 156.21 57.9707 157.345C60.5024 164.947 63.9101 172.3 67.8072 179.373C70.5182 184.293 73.5204 189.077 76.7991 193.697C76.8181 193.724 76.8363 193.751 76.8553 193.777C77.1433 194.307 77.3463 194.678 77.4313 194.833C77.4254 194.854 77.4198 194.873 77.4143 194.894C82.9573 203.198 95.2619 202.668 93.2579 192.3C94.0279 192.379 94.7163 191.925 94.7554 191.286",
    fill: "#B26E4B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5547 156.737C78.633 157.269 78.2235 157.748 77.6874 157.747C73.2225 157.741 68.7771 158.699 64.6078 160.733C62.9199 161.556 61.3425 162.524 59.8802 163.619C59.4082 163.972 58.732 163.77 58.5299 163.215L57.604 160.676C57.0565 159.174 57.6199 157.485 58.9694 156.634C60.0206 155.97 61.1004 155.398 62.4218 154.754C66.4159 152.805 70.6073 151.688 74.8146 151.333C76.4478 151.195 77.9082 152.35 78.1479 153.976L78.5547 156.737Z",
    fill: "#B1E1F4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6056 326.2V325.367C48.6056 324.738 48.2488 324.167 47.6917 323.904L36.5139 318.193C31.5434 315.846 28.3711 310.758 28.3573 305.172L33.7832 257.312H18.1492L13.6543 326.2H48.6056Z",
    fill: "#B26E4B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0352 326.2H88.9865V325.367C88.9865 324.738 88.6296 324.167 88.0725 323.904L76.8948 318.193C71.9243 315.846 68.7516 310.758 68.7381 305.172L74.164 257.312H58.5301L54.0352 326.2Z",
    fill: "#B26E4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_4265_9059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 304,
    width: 36,
    height: 23
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6543 304.76H48.6056V326.2H13.6543V304.76Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_4265_9059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3573 305.172C28.3707 310.757 31.5434 315.845 36.5139 318.193L47.6917 323.904C48.2488 324.167 48.6056 324.738 48.6056 325.367V326.2H13.6543L15.0343 304.76H28.4032L28.3573 305.172Z",
    fill: "#774331"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4152 304.76H68.784L68.7381 305.173C68.752 310.758 71.9243 315.846 76.8948 318.193L88.0729 323.904C88.6296 324.167 88.9865 324.738 88.9865 325.367V326.2H54.0352L55.4152 304.76Z",
    fill: "#774331"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2753 301.032H28.8187L28.404 304.76H15.0352L15.2753 301.032Z",
    fill: "#B2E2F4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6542 301.032H69.1976L68.7829 304.76H55.4141L55.6542 301.032Z",
    fill: "#B2E2F4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3829 188.319V181.277H15.5632C15.5806 183.185 15.5917 185.135 15.5949 187.14C15.5806 187.531 15.5782 187.923 15.5968 188.319L18.7592 247.841L14.0293 320.452C14.0293 320.452 27.8729 321.899 33.8223 316.332C27.8729 310.764 39.1077 248.662 39.1077 248.662L39.1389 247.722L39.1647 206.101H51.0756L57.9491 248.239L57.9899 248.877L54.4848 320.849C54.4848 320.849 68.3289 322.296 74.2782 316.729C68.3289 311.162 75.0715 249.129 75.0715 249.129L74.9884 249.126L75.1249 248.662L75.1553 248.393L75.1557 247.722L71.3829 188.319Z",
    fill: "#103540"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6539 96.8526L48.6096 96.8399C48.6096 96.8399 33.6779 94.7039 33.6775 94.7039C24.0657 95.7927 16.076 99.7704 12.1045 105.128C10.7328 106.547 9.94115 108.806 9.12335 110.558C7.58944 113.845 6.13267 128.431 15.5641 136.091C15.7785 141.741 15.502 174.435 15.5641 181.277H71.3833V119.024C71.3833 110.006 63.6354 101.007 48.6539 96.8526",
    fill: "#1A586B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2172 99.828L54.0512 102.001L52.8611 95.6385L46.1185 91.6619L30.6504 90.4688L31.4433 94.8431L45.6616 96.625L48.4984 104.784L51.2172 99.828Z",
    fill: "#B1E1F4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7458 78.3245H34.585L33.4258 95.2405L48.4975 104.784L47.7458 78.3245Z",
    fill: "#B26E4B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9449 52.4824C61.0555 57.004 57.3159 66.1344 50.2247 66.863C43.1335 67.5921 44.3557 56.785 44.3557 56.785L57.9449 52.4824Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3023 56.6395C49.7955 55.8692 53.5438 60.1913 55.8928 68.1551C56.2496 69.1443 58.0023 74.1768 57.5885 75.2744C57.175 76.3699 55.7432 77.0851 54.5468 77.2482C54.2156 84.4305 54.468 88.9366 47.1628 88.9366C40.9385 88.9366 34.1516 85.6681 32.9797 74.2097C32.0373 64.9913 34.2608 57.4662 42.3023 56.6395",
    fill: "#B26E4B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7792 49.9537L53.1038 49.8443C52.9091 49.0196 52.3441 48.3215 51.5651 47.9919C50.5978 47.5829 49.5691 47.329 48.5171 47.2441C44.2591 46.9002 39.4829 47.7868 36.6707 48.4472C35.1735 48.7991 33.9894 49.9411 33.5807 51.4273L31.7215 58.1829L27.3136 59.2234C25.8387 60.1738 25.339 62.1107 26.1904 63.6473C30.5552 71.5266 34.2446 83.7141 34.2446 83.7141C34.2446 83.7141 34.3814 81.3175 34.3814 72.3239C34.3814 69.5671 35.257 68.0154 37.1466 67.3494C38.0918 67.0162 38.7818 66.2094 38.9144 65.2138C40.0044 57.0108 52.032 53.9755 56.7338 59.9988C56.864 60.1658 60.4042 57.1476 58.28 53.1096C58.2737 53.0973 58.2674 53.0854 58.261 53.0735C57.3582 51.3829 55.6672 50.2596 53.7792 49.9537",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6888 67.5406V67.5406C36.6564 67.5548 36.6228 67.5667 36.5907 67.5818C35.0774 68.2855 33.9885 69.6798 33.2095 71.1585C32.5033 72.4988 32.0851 74.7896 31.7294 76.2989C31.3662 75.308 30.9717 74.264 30.5508 73.193C30.5528 73.1835 30.5536 73.1751 30.5555 73.1652L30.7043 71.8705L30.908 70.6397C30.9805 70.2172 31.0307 69.8567 31.1336 69.3442C31.3607 68.3688 31.8244 67.4358 32.4962 66.6703C33.4093 65.6286 34.6888 65.0455 35.9747 64.5933C36.3593 64.4581 36.747 64.326 37.111 64.1419C38.1935 63.5938 38.9919 62.6247 39.7804 61.7009C39.9849 61.4613 40.9574 60.3748 41.8302 59.7759C41.7903 59.812 41.7539 59.852 41.7147 59.8889C41.5976 59.9984 41.4829 60.1095 41.3717 60.2241C41.3072 60.2904 41.2447 60.3578 41.1826 60.4256C41.0769 60.5406 40.9741 60.6585 40.8744 60.7786C40.8138 60.8516 40.7537 60.9254 40.6955 61.0004C40.601 61.1214 40.5108 61.2451 40.4221 61.3709C40.3664 61.4506 40.3106 61.5303 40.2572 61.612C40.1741 61.739 40.0957 61.8699 40.019 62.0016C39.9691 62.0872 39.9181 62.1717 39.871 62.2594C39.7986 62.3939 39.7325 62.5327 39.6668 62.6715C39.6245 62.7616 39.5802 62.85 39.5406 62.9416C39.4781 63.0868 39.4235 63.2364 39.3689 63.3863C39.3357 63.4767 39.2993 63.5656 39.2692 63.6576C39.215 63.823 39.1703 63.9936 39.126 64.1642C39.1046 64.2455 39.0789 64.3248 39.0599 64.4077C39.0014 64.6628 38.9523 64.923 38.9163 65.1895C38.8653 65.5644 38.7379 65.9146 38.548 66.2236C38.2314 66.7385 37.7428 67.1391 37.1494 67.3478C36.9875 67.4045 36.836 67.4703 36.6888 67.5406",
    fill: "#3B3F41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.499 104.784L39.3766 96.0358L30.651 90.469L29.0645 95.6383L37.79 102.398L38.7922 99.1333L48.499 104.784Z",
    fill: "#B1E1F4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5919 128.58C52.327 128.261 51.0692 127.928 49.8237 127.574C46.8869 126.734 44.0267 125.737 41.2643 124.617C37.9639 123.267 34.703 121.821 31.6031 120.002C30.0953 119.117 28.6967 118.039 27.2672 117.031C26.6231 116.578 25.973 116.138 25.304 115.737C21.5204 113.468 16.6362 114.235 13.6728 117.547C12.6287 118.713 11.8588 120.14 11.4465 121.687C10.1057 126.723 12.656 130.68 16.2714 133.691C23.6178 139.95 32.9787 143.363 42.0335 145.646C45.0938 146.418 48.183 147.044 51.29 147.551C50.869 145.57 50.6475 143.519 50.6475 141.42C50.6475 136.834 51.7031 132.485 53.5919 128.58",
    fill: "#1A586B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.667 131.628C102.04 130.948 101.853 130.114 101.234 129.801C101.156 129.762 101.076 129.724 100.994 129.687C98.2007 128.477 95.5261 129.573 94.4662 130.125C93.7853 130.48 93.0795 130.745 92.355 130.923C90.3804 131.406 86.2763 132.092 78.3175 132.376C71.7609 131.92 65.2248 131.098 58.7916 129.776C57.0417 129.416 55.3084 129.013 53.5905 128.58C51.7021 132.485 50.6465 136.835 50.6465 141.42C50.6465 143.52 50.8677 145.57 51.2886 147.551C59.7368 148.928 68.3204 149.391 76.843 149.275C82.001 149.206 87.3458 148.409 92.522 147.716C95.3691 147.566 97.6365 147.425 98.1271 147.395C98.1453 147.409 98.1619 147.423 98.1801 147.436C108.536 145.89 112.717 134.255 101.667 131.628",
    fill: "#B26E4B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1957 128.402C59.7069 128.564 59.9574 129.143 59.722 129.626C57.7627 133.649 56.6767 138.075 56.6767 142.724C56.6767 144.606 56.8547 146.451 57.1962 148.248C57.3065 148.828 56.8294 149.35 56.2434 149.29L53.561 149.013C51.9748 148.849 50.7064 147.603 50.5331 146.013C50.3982 144.775 50.3574 143.551 50.3574 142.078C50.3574 137.625 51.1899 133.358 52.7123 129.41C53.303 127.877 54.9782 127.066 56.541 127.561L59.1957 128.402Z",
    fill: "#B1E1F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_9059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval1);
export default __webpack_public_path__ + "static/media/PendingApproval1.12fc530783049f742305747965152b43.svg";
export { ForwardRef as ReactComponent };